import { Schedule }   from "../../planner_base";
import {
  Global,
  CellPosition,
  LineSelectedSchedule,
  LineSelectedTask,
  LineSelectedMemo,
  LineOverSchedule
 }  from "../model";
import watch from "redux-watch";
import isEqual from 'is-equal';
import {
  PLANNER_CLICK_SCHEDULE,
  PLANNER_DRAG_SCHEDULE,
  PLANNER_CLICK_MEMO,
  PLANNER_OVER_SCHEDULE,
  PLANNER_OUT_SCHEDULE
} from 'apps/events';
import { MouseDragUtil, IMouseDragUtilOptions } from 'utilities/mouse/drag_util';
import moment from 'moment';
import { SchedulesLeft, SchedulesRight } from './schedules-left-right';
declare global {
  interface MouseEvent {
    preventUpdate: boolean;
  }
}
export class SchedulesCellSuper extends Schedule {
  selected: boolean = false;
  overSchedule: LineOverSchedule;
  mouseMoveEvent: (e:MouseEvent) => void;
  dmyMemo: HTMLElement;
  mouseDownPosition: { x: number };
  isOver: number;
  taskData(){
    return this.dataScopeTask(this.opts.task_id);
  }
  onOver(mouseEvent:MouseEvent){
    mouseEvent.preventUpdate = true;
    if(this.selected) { return; }
    this.mouseMoveEvent = (e:MouseEvent) => { this.onMove(e); }
    this.rootElement().addEventListener('mousemove', this.mouseMoveEvent);
    this.dispatchOverEvent(mouseEvent);
  }
  onMove(mouseEvent:MouseEvent){
    mouseEvent.preventUpdate = true;
    this.dispatchOverEvent(mouseEvent);
  }
  onOut(mouseEvent:MouseEvent){
    mouseEvent.preventUpdate = true;
    this.isOver = null;
    this.rootElement().addEventListener('mousemove', this.mouseMoveEvent);
    let e = new CustomEvent(PLANNER_OUT_SCHEDULE, { });
    document.dispatchEvent(e);
  }
  dispatchOverEvent(mouseEvent:MouseEvent){
    if(this.selected) { return; }
    let index = this.getCellIndex(mouseEvent);
    if(this.isOver == index) { return; }
    this.isOver = index;
    let overSchedule = new LineOverSchedule(this.opts.id, index, this.dmyMemo);
    let currentOverSchedule:LineOverSchedule = Global.getPlannerData().overSchedule;
    if(currentOverSchedule && currentOverSchedule.isSame(overSchedule)){ return; }
    this.setDmyMemoPosition(index);
    let e = new CustomEvent(PLANNER_OVER_SCHEDULE, { detail: overSchedule });
    document.dispatchEvent(e);
  }
  resetPosition(startPlus:number = 0, endPlus:number = 0): CellPosition{
    let pos = new CellPosition(this.opts.start_time, this.opts.end_time, startPlus, endPlus);
    pos.setStyleFor(this.rootElement());
    return pos;
  }
  getCellIndex(e:MouseEvent){
    return Math.floor(e.offsetX / Global.getCellWidth());
    // return Math.floor(e.layerX / Global.getCellWidth());
  }
  setDmyMemoPosition(index: number){
    this.dmyMemo.style.left = (index * Global.getCellWidth()) + 'px'
  }
}
export class SchedulesCell extends SchedulesCellSuper {
  // １度目のクリックはスケジュール選択のためメモは選択されない。その判断flag
  allowClick: boolean = false;
  dragUtil: MouseDragUtil;
  dragUtilOptions: IMouseDragUtilOptions;
  oneDayFlg: boolean = false;
  left: SchedulesLeft;
  right:SchedulesRight;
  isDown: number;
  init(){
    super.init();
    this.watch();
    this.watchPlannerData('selectedSchedule', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeSelectedSchedule(newVal, oldVal, objectPath)});
    let pos = new CellPosition(this.opts.start_time, this.opts.end_time);
    if(pos.isStartOverRight || pos.isEndOverLeft){
      this.listenMount([this.onMountToUnmount])
      return;
    }
    pos.setStyleFor(this.rootElement());
    this.isDown = 0;
    this.dragUtilOptions = {
      onDrag: () => { this.onDragging() },
      onEnd: () => { this.onEndDrag() },
      unitX: Global.getCellWidth(),
      unitY: 0
    };
    this.setFlags(pos);
    this.onSelectedSchedule(this.getPlannerData().selectedSchedule);
    this.listenMount([this.onMountSchedulesCell])
  }
  onMountToUnmount(){
    let el = this.rootElement()
    el.parentNode.removeChild(el);
    this.unmount();
  }
  onMountSchedulesCell(){
    this.dmyMemo = <HTMLElement>this.querySelector('.dmy-memo');
    this.left = this.tags['orders-planner-line-ui-schedules-left'] as any;
    this.right = this.tags['orders-planner-line-ui-schedules-right'] as any;
  }
  onChangeStore(newVal, oldVal, objectPath){
    super.onChangeStore(newVal, oldVal, objectPath);
    if(!this.selected) { return; }
    if(this.dragUtil){ return; }
    if(this.left.dragUtil){ return; }
    if(this.right.dragUtil){ return; }
    let pos: CellPosition = this.resetPosition();
    this.setFlags(pos);
  }
  setFlags(pos: CellPosition){
    this.oneDayFlg = (pos.number() <= 1);
  }
  onChangeSelectedSchedule(selectedSchedule: LineSelectedSchedule, oldVal, objectPath) {
    this.onSelectedSchedule(selectedSchedule);
  }
  onSelectedSchedule(selectedSchedule){
    if(selectedSchedule == null || selectedSchedule.scheduleId != this.opts.id){
      this.unSelect();
    } else {
      this.select(selectedSchedule);
    }
  }
  unSelect(){
    if(!this.selected){ return; }
    this.selected = false;
    this.update();
  }
  select(selectedSchedule: LineSelectedSchedule){
    this.selected = true;
    this.update();
  }
  onClick(mouseEvent:MouseEvent){
    mouseEvent.preventUpdate = true;
    if(!this.allowClick){ return; }
    if(!this.selected){ return; }
    if(Math.abs(mouseEvent.pageX - this.mouseDownPosition.x) > 5) { return; }
    let index = this.getCellIndex(mouseEvent);
    this.setDmyMemoPosition(index);
    let selectedMemo: LineSelectedMemo = new LineSelectedMemo(this.opts.line_id, this.opts.id, index, this.dmyMemo);
    let e = new CustomEvent(PLANNER_CLICK_MEMO, { detail: selectedMemo });
    document.dispatchEvent(e);
  }
  onDown(mouseEvent:MouseEvent){
    mouseEvent.preventUpdate = true;
    this.allowClick = this.selected;
    this.mouseDownPosition = { x: mouseEvent.pageX };
    if(this.opts.updating){ return false; }
    if(!this.selected){
      let selectedSchedule: LineSelectedSchedule = new LineSelectedSchedule(this.opts.id, this.opts.line_id)
      let e = new CustomEvent(PLANNER_CLICK_SCHEDULE, { detail: selectedSchedule });
      document.dispatchEvent(e);
    }
    // this.dispatch({dragging: true})
    this.dragUtil = new MouseDragUtil(mouseEvent, this.dragUtilOptions);
  }
  onDragging(){
    let stepX = this.dragUtil.pos().stepX;
    this.resetPosition(stepX, stepX)
  }
  onEndDrag(){
    // this.dispatch({dragging: false})
    let stepX = this.dragUtil.pos().stepX;
    this.resetPosition(stepX, stepX)
    let e = new CustomEvent(PLANNER_DRAG_SCHEDULE, { detail: {stepX: stepX, scheduleId: this.opts.id } });
    document.dispatchEvent(e);
    this.dragUtil = undefined;
  }
}
export class SchedulesCellUneditable extends SchedulesCellSuper {
  init(){
    super.init();
    this.watch();
    let pos = new CellPosition(this.opts.start_time, this.opts.end_time);
    pos.setStyleFor(this.rootElement());
    this.listenMount([this.onMountSchedulesCell])
  }
  onMountSchedulesCell(){
    this.dmyMemo = <HTMLElement>this.querySelector('.dmy-memo');
  }
  onDown(mouseEvent:MouseEvent){
    mouseEvent.preventUpdate = true;
  }
}
riot.mixin('orders.planner.line-ui.schedules-cell', SchedulesCell as riot.TagMixin)
riot.mixin('orders.planner.line-ui.schedules-cell-uneditable', SchedulesCellUneditable as riot.TagMixin)
